import {createSelector} from 'reselect';

/**
 * Selects a header from the state.
 * @param {Object} state A state containing a header namespace.
 * @return {Object} A header namespace.
 */
const headerSelector = createSelector(
  (state = {}) => state.header,
  (header = {}) => header
);

/**
 * Selects a device from the state.
 * @param {Object} state A state containing a device namespace.
 * @return {string?} A device namespace.
 */
const deviceSelector = createSelector(
  (state = {}) => state.device,
  (device = {}) => device
);

/**
 * Selects a virtual assistant from the state.
 * @param {Object} state A state containing a virtual assistant namespace.
 * @return {Object} A virtual assistant namespace.
 */
const virtualAssistantSelector = createSelector(
  (state = {}) => state.virtual_assistant,
  (virtual_assistant = {}) => virtual_assistant
);

/**
 * Selects a sub categories navigation from the state.
 * @param {Object} state A state containing a sub categories navigation.
 * @return {string?} A sub categories navigation.
 */
const subCategoriesNavSelector = createSelector(headerSelector, (header = {}) => header.subCatNav);

/**
 * Selects a multi-layered navigation menu from the state.
 * @param {Object} state A state containing a multi-layered navigation menu.
 * @return {string?} A multi-layered navigation menu.
 */
const multiLayeredMenuSelector = createSelector(headerSelector, (header = {}) => header.multiLayeredMenu);

/**
 * Selects a device type from the state.
 * @param {Object} state A state containing a device namespace with type.
 * @return {string?} A device type.
 */
const deviceTypeSelector = createSelector(deviceSelector, (device = {}) => device.type);

/**
 * Selects a webphoneEnabled property from the state.
 * @param {Object} state A state containing a virtual assistant namespace.
 * @return {boolean?} A webphoneEnabled property for virtual assistant.
 */
const webphoneSelector = createSelector(
  virtualAssistantSelector,
  (virtual_assistant = {}) => virtual_assistant.webphoneEnabled
);

/**
 * Selects an inbentaEnabled property from the state.
 * @param {Object} state A state containing a virtual assistant namespace.
 * @return {boolean?} An inbentaEnabled property for virtual assistant.
 */
const inbentaSelector = createSelector(
  virtualAssistantSelector,
  (virtual_assistant = {}) => virtual_assistant.inbentaEnabled
);

/**
 * Selects a login type from the state.
 * @param {Object} state A state containing a login namespace with type.
 * @return {string?} A login type.
 */
const loginTypeSelector = createSelector(
  (state = {}) => state.login,
  (login = {}) => login.loginType
);

export {
  deviceTypeSelector,
  inbentaSelector,
  loginTypeSelector,
  subCategoriesNavSelector,
  webphoneSelector,
  multiLayeredMenuSelector,
};
